import { RouteComponentProps } from 'react-router-dom';
import isArray from 'lodash/isArray';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { IProviderListData } from '../providersPayment/types';

import { fetchProvidersMerchantsRequest } from './requestHandlers';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadProvidersStart = createAction('providers_payout/load/start');
export const loadProvidersSuccess = createAction<IProviderListData>('providers_payout/load/success');
export const loadProvidersMerchantsSuccess = createAction<IProviderListData>('providers_payout/merchants/load/success');

export const loadProvidersPayoutMerchantsRequest = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<boolean> => {
    if (isInitialLoading) {
      dispatch(loadProvidersStart());
    }

    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });

    if (mergedParams?.providerNameSelect) {
      mergedParams.providerNameSelect = isArray(mergedParams.providerNameSelect)
        ? mergedParams.providerNameSelect
        : [mergedParams.providerNameSelect];
    }
    const data = await fetchProvidersMerchantsRequest(mergedParams);
    if (data) {
      dispatch(loadProvidersMerchantsSuccess(data));
    }
    history.replace({
      search: qs.stringify(mergedParams, { skipNull: true }),
    });

    return true;
  };
};
